<template>
  <div>
    <el-form
      ref="forms"
      :model="appVersionForm"
      label-width="80px"
      :rules="rules"
    >
      <el-form-item label="应用版本" prop="version">
        <el-input
          v-model="appVersionForm.version"
          style="width: 200px"
          :disabled="Object.keys(editVersion).length > 0"
        ></el-input>
      </el-form-item>
      <el-form-item label="架构" prop="arch">
        <el-checkbox-group v-model="appVersionForm.arch">
          <el-checkbox
            v-for="arch in checkedArchArr"
            :label="arch"
            :key="arch"
            >{{ arch }}</el-checkbox
          >
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="配置" prop="cmd">
        <div :class="[isFullScreen ? 'pad100' : 'pad40']">
            <codemirror
                style="height: 300px;"
                v-model="appVersionForm.cmd"
                :options="cmOptions"
            />
        </div>
        <div class="defaultFullScreenStyle" :class="[isFullScreen ? 'isFullScreen' : 'fullScreen']">
            <div @click="handleIsFullScreen" style="margin: 0 20px; color: #fff">
                <img :src="isFullScreen ? notFullscreenIcon : fullscreenIcon" alt="">
            </div>
          </div>
      </el-form-item>

      <el-form-item label="版本描述" prop="description">
        <textarea
          v-model="appVersionForm.description"
          style="
            width: 400px;
            padding: 10px;
            border: 1px solid #e3e3e3;
            border-radius: 6px;
          "
        ></textarea>
      </el-form-item>
      <el-form-item prop="detail" label="版本详情">
        <MdEditor :content.sync="appVersionForm.detail"></MdEditor>
      </el-form-item>
      <el-form-item>
        <el-button
          class="save_btn"
          type="primary"
          @click="submit"
          :loading="Loading"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import fullscreenIcon from '@/assets/images/fullscreen.svg';
import notFullscreenIcon from '@/assets/images/notFullscreen.svg';
// import language js
import 'codemirror/mode/yaml/yaml.js';
// import theme style
import 'codemirror/theme/base16-dark.css';
import 'codemirror/addon/display/fullscreen.css';
import 'codemirror/addon/display/fullscreen.js';
const yaml = require('js-yaml');
import { uploadDocker } from '@/api/app';
export default {
  name: 'AppDockerComposeCreate',
  components: {},
  props: {
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function,
    appType: String,
    appID: String,
    editVersion: Object,
    editFun: Function
  },
  data() {
    // const checkTemplate = (rule, value, callback) => {
    //   try {
    //     const template = yaml.load(value);
    //     if (!template.spec.url) {
    //       callback('spec.url 是必填项');
    //     }
    //     if (!template.spec.createUser.path) {
    //       callback('spec.createUser.path 是必填项');
    //     }
    //     if (template.spec.lockUser && !template.spec.lockUser.path) {
    //       callback('spec.lockUser.path 是必填项');
    //     }
    //     if (template.spec.deleteUser && !template.spec.deleteUser.path) {
    //       callback('spec.deleteUser.path 是必填项');
    //     }
    //     callback();
    //   } catch (err) {
    //     callback('不符合yaml格式' + err);
    //   }
    // };
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      mode: 'default',
      centerDialogVisible: false,
      Loading: false,
      fullscreenIcon,
      notFullscreenIcon,
      fileList: [],
      isFlag: true,
      fileFormData: [],
      isFullScreen: false,
      checkedArchArr: ['arm64', 'amd64'],
      appVersionForm: {
        version: '',
        versionAlias: '',
        description: '',
        arch: [],
        detail: '',
        cmd: ''
      },
      editor: null,
      toolbarConfig: {
        excludeKeys: ['uploadVideo', 'fullScreen', 'emotion']
      },
      cmOptions: {
        height: '200px',
        tabSize: 2,
        mode: 'text/yaml',
        theme: 'base16-dark',
        lineWrapping: true,
        extrakeys: { 'Ctrl-Space': 'autocomplete' },
        lineNumbers: true,
        styleActiveLine: true,
        cursorHeight: '20px',
        line: true,
        matchBrackets: true,
        fullScreen: false,
        showCursorWhenSelecting: false
      },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            customUpload: this.uploadImg
          }
        }
      },
      rules: {
        version: [{ required: true, message: '请输入应用版本' }],
        versionAlias: [{ required: true, message: '请输入应用版本别名' }],
        arch: [{ required: false, message: '请选择架构', trigger: 'blur' }],
        detail: [{ required: true, message: '请输入版本详情' }],
        cmd: [
          {
            required: true,
            message: 'Docker compose 不能为空',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    }),
    myorgs() {
      return this.$store.state.user.userOrgs;
    }
  },
  created() {
    if (Object.keys(this.editVersion).length > 0) {
      this.appVersionForm = this.editVersion;
    }
  },
  mounted() {

  },
  methods: {
    uploadImg(file, insertFn) {
      const imgData = new FormData();
      imgData.append('file', file);
      axios({
        url: this.uploadConfig.api,
        method: 'post',
        data: imgData
      }).then((response) => {
        insertFn(response.data.FileURL);
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor);
    },
    submit() {
      const obj = {
        marketID: this.marketID,
        appID: this.appID,
        version: this.appVersionForm.version,
        versionAlias: '',
        description: this.appVersionForm.description,
        arch:
          this.appVersionForm.arch && this.appVersionForm.arch.length > 0
            ? this.appVersionForm.arch.join(',')
            : '',
        detail: this.appVersionForm.detail,
        cmd: this.appVersionForm.cmd,
        templateType: 'dockerCompose'
      };
      this.$refs.forms.validate((valid) => {
        if (valid) {
          this.Loading = true;
          if (Object.keys(this.editVersion).length > 0) {
            obj.is_plugin = this.appVersionForm.is_plugin;
            obj.templateType = this.appVersionForm.templateType;
            obj.enable = this.appVersionForm.enable;
            this.editFun(obj);
          } else {
            uploadDocker(obj)
              .then((res) => {
                this.Loading = false;
                this.$message({
                  message: '上传成功',
                  type: 'success'
                });
                this.onSuccess();
              })
              .catch((err) => {
                this.Loading = false;
                this.$message({
                  message: '上传失败',
                  type: 'error'
                });
              });
          }
        }
      });
    },
    close() {
      this.onClose && this.onClose();
    },
    // 自定义上传文件
    uploadFile(file) {},
    handleChange(file, fileList) {
      this.fileList = [];
      this.fileFormData = [];
      this.fileList = fileList;
      const formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append('file', file.raw); // 拿到存在fileList的文件存放到formData中
      });
      this.fileFormData = formData;
    },
    // 点击文件
    handlePreview(file) {},
    // 删除文件
    handleRemove(file, fileList) {
      this.fileList = [];
      this.fileFormData = [];
      this.fileList = fileList;
      const formData = new FormData();
      this.fileList.forEach((file) => {
        formData.append('file', file.raw); // 拿到存在fileList的文件存放到formData中
      });
      this.fileFormData = formData;
    },
    handleIsFullScreen() {
      this.isFullScreen = !this.isFullScreen;
      this.cmOptions.fullScreen = this.isFullScreen;
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.zIndex{
    z-index: 9999;
}
.defaultFullScreenStyle {
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: 'pointer';
  top: 0;
  background: #333;
  line-height: 1px;
  padding: 9px 0 6px 0;
  height: 36px;
}
.isFullScreen {
    position: fixed;
    top: 60px;
    right: 5px;
    width: 100%;
    z-index: 9999;
    color: #fff;
    background: #333;
}
.fullScreen{
    position: absolute;
    width: 100%;
    z-index: 4;
}
pre {
  line-height: 20px;
}
.inputdesc {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
}

.uploadHelm {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  border: 1px solid #e3e3e3;
  border-radius: 5px;

  .iconUpload {
    width: 90px;
  }

  .fileUpload {
    // width: calc(100% - 90px);
    // margin-left: 12px;
  }
}

.dialog {
}

::v-deep .el-dialog__body {
  min-height: 300px;
}

::v-deep .el-upload {
  color: #415d94;
  font-weight: 600;
  border: 2px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  text-align: center;
  padding: 20px;
  background-color: #fafafa;
  transition: border-color 0.3s;

  &:hover {
    border-color: #409eff;
  }

  p {
    margin: 8px 0;
    font-size: 14px;
    line-height: 1.5;
  }

  img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
}

::v-deep .el-upload__tip {
  color: #8d8d8d;
}

// ::v-deep .el-upload-list{
//     display: none;
// }
.helmInfo {
  width: 100%;
  padding: 12px;
  min-height: 300px;

  h3 {
    font-weight: 550;
  }

  p {
    margin-top: 16px;
    display: flex;

    span {
      display: block;
    }

    span:last-child {
      width: calc(100% - 124px);
      font-weight: 550;
      margin-left: 12px;
    }

    span:first-child {
      width: 100px;
      text-align: right;
    }
  }

  // background-color: cornflowerblue;
}

.uploadBox {
  width: 100px;
  height: 80px;
  border: 1px solid #dcdfe6;
  border-radius: 5px;

  p {
    margin-top: -12px;
    color: #606266;
    font-weight: 400;
  }
}
::v-deep .CodeMirror pre.CodeMirror-line {
  line-height: 20px !important;
}
::v-deep .cm-s-base16-dark .CodeMirror-linenumber {
  line-height: 20px !important;
}
::v-deep .CodeMirror-cursors {
  line-height: 20px !important;
}
.code-mirror {
  font-size: 13px;
  line-height: 150%;
}
.pad40{
    ::v-deep .cm-s-base16-dark.CodeMirror{
        padding-top: 40px;
    }
}
.pad100{
    ::v-deep .cm-s-base16-dark.CodeMirror{
        padding-top: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/publishApp/components/appDockerComposeCreate.vue